import {Component, inject, OnInit, signal, ChangeDetectionStrategy} from '@angular/core';
import {NavigationEnd, RouteConfigLoadEnd, RouteConfigLoadStart, Router, RouterOutlet} from '@angular/router';
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {ViewportScroller} from "@angular/common";
import {AppMsalAuthService} from "./core/auth/authentication-service/app-msal-auth.service";

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    MatProgressSpinnerModule,
  ],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  router = inject(Router);
  viewPortScroller = inject(ViewportScroller);
  protected authService = inject(AppMsalAuthService);

  loadingRouteConfig = signal(false);

  title = 'SSBA Training Facility';

  ngOnInit() {
    this.authService.setupSubscriptions();
    /**
     * Handle module lazy loading state
     * https://stackoverflow.com/questions/42981136/show-activity-indicator-while-loading-a-lazy-loaded-module-in-angular-2
     */
    this.router.events
      .subscribe(event => {
        if (event instanceof RouteConfigLoadStart) {
          this.loadingRouteConfig.set(true);
        } else if (event instanceof RouteConfigLoadEnd) {
          this.loadingRouteConfig.set(false);
        } else if (event instanceof NavigationEnd) {
          this.viewPortScroller.scrollToPosition([0, 0]);
        }
      });
  }
}
